import React from 'react';

const ClusterAddPage = React.lazy(() => import('pages/Cluster/ClusterAddPage'));
const ClusterPage = React.lazy(() => import('pages/Cluster/ClusterPage'));

const cluster = [
  {
    path: '/cluster',
    exact: true,
    name: 'Danh sách chi nhánh',
    function: 'MD_CLUSTER_VIEW',
    component: ClusterPage,
  },
  {
    path: '/cluster/add',
    exact: true,
    name: 'Thêm mới chi nhánh',
    function: 'MD_CLUSTER_ADD',
    component: ClusterAddPage,
  },
  {
    path: '/cluster/edit/:cluster_id',
    exact: true,
    name: 'Chỉnh sửa chi nhánh',
    function: 'MD_CLUSTER_EDIT',
    component: ClusterAddPage,
  },
  {
    path: '/cluster/detail/:cluster_id',
    exact: true,
    name: 'Chi tiết chi nhánh',
    function: 'MD_CLUSTER_VIEW',
    component: ClusterAddPage,
  },
];

export default cluster;
